<template>
	<div class="auth-wrapper auth-v2">
		<b-row class="auth-inner m-0">

			<!-- Brand logo-->
			<b-link class="brand-logo">
				<vuexy-logo />
				<h2 class="brand-text text-primary ml-1">TMS</h2>
			</b-link>
			<!-- /Brand logo-->

			<!-- Left Text-->
			<b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
				<div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
					<b-img fluid class="login-img" :src="sideImg" alt="Login V2"/>
				</div>
			</b-col>
			<!-- /Left Text-->

			<!-- Login-->
			<b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
				<b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
					<b-card-title title-tag="h2" class="font-weight-bold mb-1">
						TMS'ye hoş geldiniz! 👋
					</b-card-title>
					<b-card-text class="mb-2">
						Sistemi kullanabilmek için lütfen giriş yapınız.
					</b-card-text>

					<!-- form -->
				
					<b-form class="auth-login-form mt-2" @submit.prevent>
						<template v-if="!otp">
							<b-form-group label="Kullanıcı Adı" label-for="login-email">
								<v-validator :errors="errors" parameter="Username" :watch="username">
									<b-form-input id="login-email" v-model="username" name="login-email" placeholder="Kullanıcı Adı"/>
								</v-validator>
							</b-form-group>

							<!-- forgot password -->
							<b-form-group>
								<div class="d-flex justify-content-between">
									<label for="login-password">Parola</label>
									<b-link :to="{name:'forgot-password'}">
										<small>Şifrenizi mi unuttunuz?</small>
									</b-link>
								</div>
								<v-validator :errors="errors" parameter="Password" :watch="password">
									<b-input-group class="input-group-merge">
										<b-form-input id="login-password" v-model="password" class="form-control-merge" :type="passwordFieldType" name="login-password" placeholder="············"/>
										<b-input-group-append is-text>
											<feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility"/>
										</b-input-group-append>
									</b-input-group>
								</v-validator>
							</b-form-group>
						</template>
						<!-- email -->
						

						<div class="text-center mb-1" v-else>
							<small class="d-block mb-1">
								Giriş yapabilmek için SMS ile gönderilen 6 haneli kodu giriniz.
							</small>
							<v-pin-code v-model="code"></v-pin-code>
							<button class="btn mt-75 btn-sm btn-flat-secondary" tabindex="-1" type="button" v-on:click="clear">Başka bilgiler ile giriş yap</button>
						</div>
						
					
						<b-button type="submit" variant="primary"  class="d-flex align-items-center justify-content-center" block :disabled="loading" v-on:click="submit">
							<b-spinner small class="mr-50" v-if="loading"></b-spinner>
							Giriş Yap
						</b-button>
					</b-form>
				</b-col>
			</b-col>
		<!-- /Login-->
		</b-row>
	</div>
</template>

<script>
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import AuthApi from '@/api/auth'
import Auth from '@/utilities/auth'
import VPinCode from '@/components/VPinCode.vue'

export default {
	components: {
		BRow,
		BCol,
		BLink,
		BFormGroup,
		BFormInput,
		BInputGroupAppend,
		BInputGroup,
		BFormCheckbox,
		BCardText,
		BCardTitle,
		BImg,
		BForm,
		BButton,
		BSpinner,
		VuexyLogo,
		VPinCode
	},
	mixins: [togglePasswordVisibility],
	data() {
		return {
			status: '',
			password: '',
			username: '',
			code:'',
			otp:false,
			errors:{},
			sideImg: require('@/assets/images/pages/login-logistic.svg'),
			loading:false,
		}
	},
	computed: {
		passwordToggleIcon() {
			return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
		},
	},
	methods: {
		clear(){
			this.username = ''
			this.password = ''
			this.code = ''
			this.otp = false
		},
		submit() {  
			this.loading = true
			AuthApi.Login({
				Username: this.username,
				Password: this.password,
				IsFromOTP: this.otp,
				OTPCode: this.code || null
			})
			.then((res)=> {
				this.loading = false
				try{
					if(res.data.Success){
						if(res.data.Data?.IsOTPRequired == true){
							this.otp = true
						}else{
							this.$result(res)
							Auth.isAuthenticated = true
							Auth.user = res.data.Data
							this.$signalr.role.Configure()
							this.$signalr.notify.Configure()
							this.$signalr.gStatus.Configure()
							this.$signalr.userActive.Configure()
							this.$nextTick(()=>{
								if(this.$route.query?.redirect && this.$route.query?.redirect != '/Auth/Login'){
									this.$router.push(this.$route.query.redirect)
								}else {
									this.$router.push({name:"home"})
								}
							})
						}
					}else this.$result(res)
				}catch(err){
					console.log(err)
				}
			})
			.catch((err)=> {
				this.loading = false
				this.$result(null,err)
			})
		},
	},
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
